import React from 'react';
import { useTranslations } from 'next-intl';

import { IRequiredSubjects } from 'modules/online-olympic';

import TimerBox from '../timer-box';

interface IProps {
  requiredSubjects?: IRequiredSubjects[];
  startedTime?: number;
  status?: string;
}

const FixedSubject: React.FC<IProps> = ({ requiredSubjects, startedTime, status }) => {
  const t = useTranslations();

  return (
    <div className="rounded-xl bg-white p-4 sm:m-3 sm:mx-0">
      <div className="mt-2 mb-4 rounded-lg bg-gray-50 p-2 font-medium">
        <div className="flex items-center justify-between">
          <p className="font-semibold">{t('fanlar')}</p>
          <p className="text-sm text-gray-700">{t('savollar_soni')}</p>
        </div>
        <hr className="!my-2 border-gray-200 bg-gray-50" />
        <div className="space-y-1 text-sm">
          {requiredSubjects?.map(subject => (
            <div key={subject?.id} className="flex items-center justify-between">
              <p className="text-gray-800">{subject?.name}</p>
              <p className="text-gray-700">
                {subject?.question_count} {t('ta')}
              </p>
            </div>
          ))}
        </div>
      </div>
      <TimerBox status={status} time={startedTime} />
    </div>
  );
};

export default FixedSubject;
